export const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;
export const SKIP_COOLDOWN_MS = 30 * 24 * 60 * 60 * 1000;

// Logins in the last 5 minutes count as the current login, so we skip them.
const CURRENT_LOGIN_WINDOW_MS = 5 * 60 * 1000;

/**
 * True if the previous login was over a year ago.
 * Skips the current login (last few minutes) and checks the one before it.
 */
export const loggedInOverAYearAgo = (
  lastLogins: number[],
  now: number,
): boolean => {
  const previous = lastLogins.find((t) => now - t > CURRENT_LOGIN_WINDOW_MS);
  return previous !== undefined && now - previous > ONE_YEAR_MS;
};

/** True if the user skipped enforcement within the last 30 days. */
export const skippedRecently = (
  lastSkip: number | undefined,
  now: number,
): boolean => lastSkip !== undefined && now - lastSkip < SKIP_COOLDOWN_MS;
